import { render } from "./editProductList.vue?vue&type=template&id=51762b82&scoped=true"
import script from "./editProductList.vue?vue&type=script&lang=js"
export * from "./editProductList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-51762b82"

export default script